import { FamilyPlanCheckApi, getExternalId } from "../api/api";
import { SequenceManagerAction } from "./SequenceManagerAction";

const FamilyPlanCheckAction = {
  FAMILY_PLAN_CHECK_SUCCESS: "FAMILY_PLAN_CHECK_SUCCESS",
  FAMILY_PLAN_CHECK_FAILURE: "FAMILY_PLAN_CHECK_FAILURE",
  GET_EXTERNAL_ID_SUCCESS: "GET_EXTERNAL_ID_SUCCESS",
  GET_EXTERNAL_ID_FAILURE: "GET_EXTERNAL_ID_FAILURE",
  FAMILY_PLAN_CHECK_DONE: "FAMILY_PLAN_CHECK_DONE"
}

const getPackageExternalId = (productKey: any) => {
  return function (dispatch: any) {
    getExternalId(productKey).then((response) => {
      dispatch({ type: FamilyPlanCheckAction.GET_EXTERNAL_ID_SUCCESS, payload: response.data });
    })
      .catch((error) => {
        //Display error
        dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
      })
  }
}

const familyPlanValidation = (custType: any, actType: any) => {
  return function (dispatch: any) {
    FamilyPlanCheckApi(custType, actType).then((response) => {
      dispatch({ type: FamilyPlanCheckAction.FAMILY_PLAN_CHECK_SUCCESS, payload: response });
    })
      .catch((error) => {
        //Display error
        dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
      })
  }
}

const familyPlanCheckDone = (familyPlanCheckResponse: any, ErrorCode: any, ErrorDescription: any, offerContainerId: any, planCheckValue: any, redirectUrl: any = "") => {
  return function (dispatch: any) {
    dispatch({ type: FamilyPlanCheckAction.FAMILY_PLAN_CHECK_DONE, payload: { familyPlanCheckResponse: familyPlanCheckResponse, ErrorCode: ErrorCode, ErrorDescription: ErrorDescription, offerContainerId: offerContainerId, planCheckValue: planCheckValue, redirectUrl: redirectUrl } });
    dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['FamilyPlanCheck'] });
  }
}

export { FamilyPlanCheckAction, familyPlanValidation, getPackageExternalId, familyPlanCheckDone };
